/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_Sync_Mode_Long_PressInputs */



/**
* | output |
* | --- |
* | "Long Press" |
*
* @param {Timing_Sync_Mode_Long_PressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_sync_mode_long_press = /** @type {((inputs?: Timing_Sync_Mode_Long_PressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_Sync_Mode_Long_PressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Appui long")
	if (locale === "de") return /** @type {LocalizedString} */ ("Langes Drücken")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pressione lunga")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Длительное нажатие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pulsación larga")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("长按")
	if (locale === "ja") return /** @type {LocalizedString} */ ("長押し")
	if (locale === "hi") return /** @type {LocalizedString} */ ("देर तक दबाए रखें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pressione e segure")
	return /** @type {LocalizedString} */ ("Long Press")
});